import copyData from "../data/copy.json";

type CopyPath = string | string[];

/**
 * Gets copy text from the centralized copy JSON file
 * @param path - Path to the copy text, either as a string with dots or an array of strings
 * @param defaultText - Default text to return if the path doesn't exist
 * @returns The requested copy text or the default text
 */
export function getCopy(path: CopyPath, defaultText: string = ""): string {
  const pathArray = typeof path === "string" ? path.split(".") : path;
  let current: any = copyData;

  for (const key of pathArray) {
    if (current && Object.prototype.hasOwnProperty.call(current, key)) {
      current = current[key];
    } else {
      return defaultText;
    }
  }

  return typeof current === "string" ? current : defaultText;
}

/**
 * Gets a nested object from the copy JSON file
 * @param path - Path to the copy object, either as a string with dots or an array of strings
 * @returns The requested object or undefined if not found
 */
export function getCopyObject<T = any>(path: CopyPath): T | undefined {
  const pathArray = typeof path === "string" ? path.split(".") : path;
  let current: any = copyData;

  for (const key of pathArray) {
    if (current && Object.prototype.hasOwnProperty.call(current, key)) {
      current = current[key];
    } else {
      return undefined;
    }
  }

  return current as T;
}

export default copyData;
